import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import IncentiveCard from '../IncentiveCard/IncentiveCard';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { sortIncentivesCatalog } from '../../functions/incentives/Sort/sortIncentivesCatalog';
import Slider from 'react-slick';
import './IncentiveCatalog.scss';

const IncentiveCatalog = ({ incentives, carousel, main, purchaseMethod }) => {
  const removeSlickSlideAttributes = () => {
    document.querySelectorAll('.slick-slide').forEach((slide) => {
      slide.removeAttribute('aria-hidden');
      slide.removeAttribute('tabindex');
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (document.querySelector('.slick-slide')) {
        removeSlickSlideAttributes();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const sortedIncentives = sortIncentivesCatalog(
    incentives,
    'typicalAmount',
    'desc'
  );

  let slidesToShow = 4;
  if (sortedIncentives.length < slidesToShow) {
    slidesToShow = sortedIncentives.length;
  }

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    arrows: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    onInit: removeSlickSlideAttributes,
    afterChange: removeSlickSlideAttributes,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  if (!incentives) return <LoadingSpinner />;

  return carousel ? (
    <div className="carousel-incentives-list">
      <Slider {...sliderSettings}>
        {sortedIncentives?.map((incentive, index) => (
          <IncentiveCard
            incentive={incentive}
            key={index}
            purchaseMethod={purchaseMethod}
          />
        ))}
      </Slider>
    </div>
  ) : (
    <div className="incentives-list">
      {sortedIncentives?.map((incentive, index) => (
        <IncentiveCard
          incentive={incentive}
          key={index}
          purchaseMethod={purchaseMethod}
        />
      ))}
    </div>
  );
};

export default IncentiveCatalog;

IncentiveCatalog.propTypes = {
  incentives: PropTypes.array,
  titleText: PropTypes.element,
  includeTotal: PropTypes.bool,
};
